import { ref } from 'vue'
import { defineStore } from 'pinia'
import { getStoredUserOrgId } from '@/api/auth'
import { fetchCaseWorkPage } from '@/api/case'

/**
 * 待办 / 已办任务数量：待办/已办页标题角标共用。
 * 与列表接口同源（size=1 只取 total），不含筛选条件。
 * 未绑定部门时固定为 0，不请求接口。
 */
export const useCaseWorkCountStore = defineStore('caseWorkCount', () => {
  const todoCount = ref(0)
  const doneCount = ref(0)
  const loaded = ref(false)
  let inflight: Promise<void> | null = null

  async function refresh() {
    if (!String(getStoredUserOrgId() || '').trim()) {
      todoCount.value = 0
      doneCount.value = 0
      loaded.value = true
      return
    }
    if (inflight) return inflight
    inflight = (async () => {
      try {
        const [todoRes, doneRes] = await Promise.all([
          fetchCaseWorkPage('todo', { page: 1, pageSize: 1 }),
          fetchCaseWorkPage('done', { page: 1, pageSize: 1 }),
        ])
        todoCount.value = Math.max(0, Number(todoRes.total) || 0)
        doneCount.value = Math.max(0, Number(doneRes.total) || 0)
        loaded.value = true
      } catch {
        // 保留上次成功计数，避免失败被当成 0
      } finally {
        inflight = null
      }
    })()
    return inflight
  }

  function clear() {
    todoCount.value = 0
    doneCount.value = 0
    loaded.value = false
  }

  return { todoCount, doneCount, loaded, refresh, clear }
})
